import { put, takeEvery, call } from 'redux-saga/effects';
import { getType } from 'deox';
import { directLinkToTool, setActiveTool } from 'modules/activeTool';
import { ActiveTool, mapToolToItem } from 'types/AppState';
import { selectCurrentTransition } from 'modules/transitions';
import { isNil } from 'ramda';
import analytics from 'utils/analytics';
import { setRatioFormat } from 'modules/ratioFormat';
import { RatioFormatType } from 'types/RatioFormat';
import { applyTemplateSizeFilter } from 'modules/filters';

export function* setActiveToolSaga({ payload: tool }: ReturnType<typeof setActiveTool>) {
  if (tool !== ActiveTool.Transition) {
    yield put(selectCurrentTransition(null));
  }
}

export function* directLinkToToolSaga() {
  const params: URLSearchParams = new URLSearchParams(window.location.search);
  const fit: string | null = params.get('fit');
  const ratioFormats = RatioFormatType as Object;
  const tool: string | null = params.get('tool');

  const ratioFormatToFilter: any = {
    [RatioFormatType.Youtube]: 'youtube_cover',
    [RatioFormatType.InstagramPortrait]: 'insta_Portrait',
    [RatioFormatType.InstagramStory]: 'insta_story',
    [RatioFormatType.InstagramSquare]: 'insta_square',
    [RatioFormatType.FacebookSquare]: 'fb_post',
    [RatioFormatType.FacebookPortrait]: 'fb_square',
    [RatioFormatType.FacebookStory]: 'fb_story',
    [RatioFormatType.Tiktok]: 'tik_tok',
    [RatioFormatType.Snapchat]: 'snapchat',
    [RatioFormatType.Twitter]: 'twitter_portrait'
  };

  if (!isNil(fit) && Object.values(ratioFormats).includes(fit)) {
    yield put(setRatioFormat(fit as RatioFormatType));
    yield put(applyTemplateSizeFilter(ratioFormatToFilter[fit]));
  }

  /* Templates are hidden according to PW-24741 */
  if (
    !isNil(tool) &&
    [
      ActiveTool.RatioFormat
      // ActiveTool.Templates
    ].includes(tool as ActiveTool)
  ) {
    yield put(setActiveTool(tool as ActiveTool));
    yield call([analytics, analytics.videoEditItemOpen], mapToolToItem[tool]);
  }
}

export default function* activeToolSaga() {
  yield takeEvery(getType(setActiveTool), setActiveToolSaga);
  yield takeEvery(getType(directLinkToTool), directLinkToToolSaga);
}
